import React, { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import "./EmergencyContactModal.css";
import CustomModal from "../../CustomModal/CustomModal";
import ModalFooter from "../../CustomModal/ModalFooter";
import ModalHeader from "../../CustomModal/ModalHeader";
import CustomTextField from "../../../components/CustomTextField/CustomTextField";
import * as _ from "lodash";
import { emergencyContactType } from "../../../interfaces/myProfile/personalDetails/emergencyContactType";
import { validateEmail } from "../../../configs/utils";
import toast from "react-hot-toast";
import CustomAutoComplete from "../../../components/CustomAutoComplete/CustomAutoComplete";
import Compdirection from "../../../themes/CompDirection";

interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  callBackHandleClockIn: (data: emergencyContactType) => void;
  selectedEmployeeDetail: emergencyContactType;
  allCountriesData: [];
  trans?: any;
}

const EmergencyContactModalPresenter = ({
  isModalOpen,
  closeModal,
  allCountriesData,
  selectedEmployeeDetail,
  callBackHandleClockIn,
  trans,
}: ModalProps) => {
  const [personName, setPersonName] = useState(
    selectedEmployeeDetail.emergencyPersonName
  );
  const [personContact, setPersonContact] = useState(
    selectedEmployeeDetail.emergencyContactNumber
  );
  const [email, setEmail] = useState(selectedEmployeeDetail.emergencyEmail);
  const [country, setCountry] = useState(
    selectedEmployeeDetail.emergencyCountry
  );
  const [relationship, setRelationship] = useState(
    selectedEmployeeDetail.emergencyRelationship
  );

  const handleChangePhone = (phone: any) => {
    const regex = /^([0|+[0-9]{1,4})([0-9]{0,10})$/;
    if (phone.match(regex) || phone == "") {
      setPersonContact(phone);
    }
  };

  const handleSubmit = () => {
    if (!validateEmail(email)) {
      toast.error(trans("Email is not valid!"));
    } else {
      {
        callBackHandleClockIn({
          emergencyContactNumber: personContact,
          emergencyPersonName: personName,
          emergencyCountry: country,
          emergencyEmail: email,
          emergencyRelationship: relationship,
        });
      }
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="554px"
      modalWidth="600px"
    >
      <ModalHeader
        modal={{ modal_title: trans("Edit Emergency Contact") }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={2}
          style={{
            marginTop: "20px",
          }}
        >
          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans("Name")}
              placeholder={trans("Name")}
              value={personName}
              onChange={(e: any) => setPersonName(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            {" "}
            <CustomTextField
              type="string"
              label={trans("Relationship")}
              placeholder="Phone"
              value={relationship}
              onChange={(e: any) => setRelationship(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans("Country")}
              options={_.map(allCountriesData, (country: any) => {
                return country.name;
              })}
              value={country}
              onChange={(event: any, newValue: any) => {
                setCountry(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            {" "}
            <CustomTextField
              type="string"
              label={trans("Email")}
              placeholder={trans("Email")}
              value={email}
              onChange={(e: any) => setEmail(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            {" "}
            <CustomTextField
              type="string"
              label={trans("Phone")}
              placeholder={trans("Phone")}
              value={personContact}
              onChange={(e: any) => {
                handleChangePhone(e.target.value);
              }}
              helperText="ex. +971124578963"
            />
          </Grid>
        </Grid>
      </Compdirection>
      <Box style={{ marginTop: "35px" }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default EmergencyContactModalPresenter;
